let _pendingTab: string | null = null;
let _pendingAgent: string | null = null;

export function signalOpenCopilot(tab: string, agentId?: string): void {
  _pendingTab = tab;
  _pendingAgent = agentId ?? null;
  window.dispatchEvent(new CustomEvent('dca:open-copilot', { detail: { tab, agentId } }));
}

export function consumePendingTab(): string | null {
  const t = _pendingTab;
  _pendingTab = null;
  return t;
}

export function consumePendingAgent(): string | null {
  const a = _pendingAgent;
  _pendingAgent = null;
  return a;
}
